import type { Passenger } from '@bambi/api-client/schemas';
import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

import { formatPassengerLabel } from './formatPassengerLabel';

export function buildPassengerSelectOption(passenger: Passenger): SelectOption {
  return {
    label: formatPassengerLabel(passenger),
    value: passenger.id,
  };
}
